<template>
  <div>
    <template v-if="loaded">
      <b-row>
        <b-col xs="12">
          <h5 class="mb-3 mt-3">{{ $t("Firma Bilgileri") }}</h5>
          <b-row>
            <b-col xs="12" md="4">
              <b-form-group>
                <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Firma Adı") }} <span style="color:red">*</span></legend>
                <b-form-input v-model="company.title"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col xs="12" md="4">
              <b-form-group>
                <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Telefon Numarası") }} <span style="color:red">*</span></legend>
                <b-form-input v-model="company.phone" v-mask="'+90 (###) ### ## ##'"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col xs="12" md="4">
              <b-form-group label="Web Sitesi">
                <b-form-input v-model="company.website"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col xs="12" md="4">
              <b-form-group>
                <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Yetkili Kişi") }} <span style="color:red">*</span></legend>
                <b-form-input v-model="company.full_name"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col xs="12" md="4">
              <b-form-group>
                <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Yetkili Telefon") }} <span style="color:red">*</span></legend>
                <b-form-input v-model="company.phone2" v-mask="'+90 (###) ### ## ##'"></b-form-input>
              </b-form-group>
              <b-form-group v-if="!company.sms_confirmed">
                <b-form-input placeholder="Doğrulama Kodu" v-model="smsActivationCode" size="sm" :state="false" />
                <div class="d-flex align-items-center justify-content-between mt-2">
                  <span>
                    <a href="#" @click="sendActivationCodeAgain()" style="font-size:12px;">{{ $t("Kodu Tekrar Gönder") }}</a>
                  </span>
                  <span>
                    <b-button size="sm" variant="primary" @click="smsActivation()">{{ $t("Telefonu Doğrula") }}</b-button>
                  </span>
                </div>
              </b-form-group>
            </b-col>
         <!--    <b-col xs="12" md="4">
              <b-form-group label="Firma Logosu">
                <div class="d-flex align-items-start">
                  <img :src="company.logo_url" width="60" class="mr-2" />
                  <b-form-file
                    v-model="upload_logo"
                    @change="uploadLogo"
                    accept="image/jpeg, image/png"
                  ></b-form-file>
                </div>
              </b-form-group>
            </b-col> -->
<!--             <b-col xs="12" md="4">
              <b-form-group label="Barkod Logosu:">
                <div class="d-flex align-items-start">
                  <img :src="company.barcode_url" width="60" class="mr-2" />
                  <b-form-file
                      v-model="upload_Barcode_logo"
                      @change="uploadBarcodeLogo"
                      accept="image/jpeg, image/png"
                  ></b-form-file>
                </div>
              </b-form-group>
            </b-col> -->
          </b-row>
          <h5 class="mb-3 mt-3">{{ $t("Adres Bilgileri") }}</h5>
          <b-row>
            <b-col xs="12" md="4">
              <b-form-group label="İl">
                <b-form-select v-model="company.city" :options="cityOptions"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col xs="12" md="4">
              <b-form-group label="İlçe">
                <b-form-select v-model="company.county" :options="countyOptions"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col xs="12" md="8">
              <b-form-group label="Adres">
                <b-form-input v-model="company.address"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col xs="12" md="4">
              <b-form-group label="Posta Kodu">
                <b-form-input v-model="company.postal_code"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- <h5 class="mb-3 mt-3">Sosyal Medya</h5>
          <b-row>
            <b-col xs="12" md="4">
              <b-form-group label="İnstagram">
                <b-form-input v-model="company.instagram"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row> -->
        </b-col>
      </b-row>


      <b-row class="mt-3">
        <b-col class="text-right">
          <b-button @click.prevent="submit" variant="primary">{{ $t("Ayarları Kaydet") }}</b-button>
        </b-col>
      </b-row>
    </template>
    <div class="w-100 text-center" v-else>
      <b-spinner variant="default" />
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: "CompanySettings",
    props: ["user", "cities"],
    data() {
      return {
        loaded: false,
        upload_logo: null,
        upload_Barcode_logo: null,
        company: {},
        smsActivationCode: '',
      };
    },
    computed: {
      cityOptions() {
        return this.cities ? Object.keys(this.cities) : [];
      },
      countyOptions() {
        return this.cities ? this.cities[this.company.city] : [];
      },
    },
    methods: {
      ...mapActions(['uploadPhoto', 'updateCompanySettings', 'getUser', 'sendActivationCodeToUser', 'activateAccount']),
      sendActivationCodeAgain() {
        this.sendActivationCodeToUser().then(response => {
          this.success(response.data.message);
        }).catch(error => {
          this.error(error.response.data.message);
        });
      },
      smsActivation() {
        this.activateAccount(this.smsActivationCode).then(() => {
          window.location.href = '/';
        }).catch(error => {
          this.error(error.response.data.message);
        });
      },
      uploadLogo(e) {
        const file = e.target.files[0];
        
        const formData = new FormData();
        formData.append("file", file);
        
        this.uploadPhoto(formData).then(response => {
          this.company.logo_url = response.data.file_url;
          this.upload_logo = null;
        }).catch(error => {
        });
      },

      uploadBarcodeLogo(e) {
        const formData = new FormData();
        formData.append("file", e.target.files[0]);
        this.uploadPhoto(formData).then(response => {
          this.company.barcode_url = response.data.file_url;
          this.upload_Barcode_logo = null;


        });
      },
      submit() {
        this.updateCompanySettings(this.company)
          .then(response => {
            this.success(response.data.message);
          }).catch(error => {
          this.error(error.response.data.message);
        });
      }
    },
    async mounted() {
      this.loaded = false;
      const user = await this.getUser();
      this.company = user.company;
      this.loaded = true;
    }
  };
</script>
